var map = {
	"./appAsset--alerts-ax.svg": "./src/assets/empty-state/appAsset--alerts-ax.svg",
	"./appAsset--branch-ax.svg": "./src/assets/empty-state/appAsset--branch-ax.svg",
	"./appAsset--certificate-ax.svg": "./src/assets/empty-state/appAsset--certificate-ax.svg",
	"./appAsset--customer-address-ax.svg": "./src/assets/empty-state/appAsset--customer-address-ax.svg",
	"./appAsset--customer-ax.svg": "./src/assets/empty-state/appAsset--customer-ax.svg",
	"./appAsset--customer-contact-ax.svg": "./src/assets/empty-state/appAsset--customer-contact-ax.svg",
	"./appAsset--customer-econ-ax.svg": "./src/assets/empty-state/appAsset--customer-econ-ax.svg",
	"./appAsset--documents-ax.svg": "./src/assets/empty-state/appAsset--documents-ax.svg",
	"./appAsset--el-ax.svg": "./src/assets/empty-state/appAsset--el-ax.svg",
	"./appAsset--email-ax.svg": "./src/assets/empty-state/appAsset--email-ax.svg",
	"./appAsset--groups-ax.svg": "./src/assets/empty-state/appAsset--groups-ax.svg",
	"./appAsset--metrics-branch-ax.svg": "./src/assets/empty-state/appAsset--metrics-branch-ax.svg",
	"./appAsset--organization-ax.svg": "./src/assets/empty-state/appAsset--organization-ax.svg",
	"./appAsset--pdf-ax.svg": "./src/assets/empty-state/appAsset--pdf-ax.svg",
	"./appAsset--pos-ax.svg": "./src/assets/empty-state/appAsset--pos-ax.svg",
	"./appAsset--product-ax.svg": "./src/assets/empty-state/appAsset--product-ax.svg",
	"./appAsset--purchase-ax.svg": "./src/assets/empty-state/appAsset--purchase-ax.svg",
	"./appAsset--sire-ax.svg": "./src/assets/empty-state/appAsset--sire-ax.svg",
	"./appAsset--suppliers-ax.svg": "./src/assets/empty-state/appAsset--suppliers-ax.svg",
	"./appAsset--users-ax.svg": "./src/assets/empty-state/appAsset--users-ax.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/empty-state sync recursive ^\\.\\/appAsset\\-\\-.*\\-ax\\.svg$";